<template>
    <v-scale-transition>
        <v-card flat tile color="transparent" v-show="visible" max-width="700" v-if="editMode">
            <text-editor
                    v-model="textModel"
                    hint="Action button text">
                        <div :class="classes">{{value}}</div>
            </text-editor>
        </v-card>
        <div v-else>
            <div :class="classes" @click="clicked">{{value}}</div>
        </div>
    </v-scale-transition>
</template>

<script>

    import TextEditor from "../TextEditor";

    export default {

        components: {
            TextEditor,
        },

        props: {
            value: {
                type: String | null,
                required: true,
            },
            color: {
                type: String,
                required: true,
                validator: function (value) {
                    return ['blue', 'green', 'red'].indexOf(value) !== -1
                }
            },
            visible: {
                type: Boolean,
                required: false,
                default: true,
            },
            editMode: {
                type: Boolean,
                required: false,
                default: true,
            },
            url: {
                type: String,
                required: false,
                default: null,
            }
        },

        data() {
            return {
                data: {}
            }
        },

        computed: {
            textModel: {
                get() {
                    return this.value;
                },
                set(text) {
                    this.$emit('input', text);
                }
            },

            classes() {
                let classes = [];

                classes.push('action-button ' + 'button-' + this.color);

                if (!this.editMode) {
                    classes.push('cursor-pointer');
                }

                return classes.join(' ');
            }
        },

        methods: {
            clicked() {
                this.sendToUrl(this.url, true);
            }
        }
    }
</script>

<style scoped>

    .action-button {
        margin-top: 10px;
        margin-bottom: 10px;
        border-radius: 3px !important;
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16) !important;
        color: #FFF;
        display: inline-block;
        text-decoration: none;
        -webkit-text-size-adjust: none;
    }

    .button-blue {
        background-color: #3097D1;
        border-top: 10px solid #3097D1;
        border-right: 18px solid #3097D1;
        border-bottom: 10px solid #3097D1;
        border-left: 18px solid #3097D1;
    }

    .button-green {
        background-color: #2ab27b;
        border-top: 10px solid #2ab27b;
        border-right: 18px solid #2ab27b;
        border-bottom: 10px solid #2ab27b;
        border-left: 18px solid #2ab27b;
    }

    .button-red {
        background-color: #bf5329;
        border-top: 10px solid #bf5329;
        border-right: 18px solid #bf5329;
        border-bottom: 10px solid #bf5329;
        border-left: 18px solid #bf5329;
    }

</style>